import React, { useState, useContext, useEffect } from "react"
import styled, { createGlobalStyle } from "styled-components"
import Header from "./header/header"
import Footer from "./footer/footer"
import { useAuth } from "react-use-auth"
import { FaSignOutAlt, FaLightbulb } from "react-icons/fa"
import { UserContext } from "../state"
import Switch from "./switch/switch"
import PageTransition from "gatsby-plugin-page-transitions"
import { ToastContainer, Slide } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

// Note: html, body and font styles are done in base-styles.css
const GlobalStyle = createGlobalStyle`
    :root {
      --background-color: #fff;
      --text-color: #000;

    }

    *,
    *:before,
    *:after {
        box-sizing: inherit;
    }

    html {
        height: 100%;
        box-sizing: border-box;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        -webkit-text-size-adjust: 100%;
        -ms-text-size-adjust: 100%;
    }

    * {
      font-family: 'Roboto', Arial;
    }

    body {
        height: 100%;
        margin: 0;
        font-size: 16px;
    }

    #root {
      height: 100%;
    }

    em {
      font-style: normal;
    }

    h1, h2, h3, h4, h5 {
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 1px;
    }

    .theme-dark, .theme-light {
      transition: background-color 200ms ease, color 200ms ease;
    }

    div {
        outline: none;
    }

    .hide-in-print {
        @media print {
            display: none !important;
        }
    }

    .pagebreak { page-break-before: always; }

    h1, h2, h3, h4, h5 {
        font-weight: bold;
        page-break-after: avoid;
    }
    @media print {
        body, main {margin-top:0 !important; padding-top: 0 !important;}
        main {
            padding-bottom: 0;
        }
    }

    .tippy-tooltip {
        font-size: 16px;
        max-width: 400px !important;
    }

`

const Layout = ({ children }) => {
  const [theme, setTheme] = useState("dark")
  const { logout } = useAuth()
  const [userState, userDispatch] = useContext(UserContext)

  function logoutFunction() {
    userDispatch({ type: "reset" })
    logout()
  }

  const toggleDarkMode = () => {
    // console.log(userState)

    if (theme === "light") {
      setTheme("dark")
      localStorage.setItem("dark-theme", true)
    } else if (theme === "dark") {
      setTheme("light")
      localStorage.setItem("dark-theme", false)
    }
  }

  useEffect(() => {
    const darkTheme = localStorage.getItem("dark-theme")
    darkTheme === "true" ? setTheme("dark") : setTheme("light")
  }, [])

  return (
    <StyledLayout className={`theme-${theme}`}>
      <GlobalStyle />
      <Header>
        <MenuItem onClick={toggleDarkMode}>
          <DarkModeIcon /> Light switch
          <Switch active={theme === "dark"} />
        </MenuItem>
        {userState && userState._id && (
          <MenuItem onClick={() => logoutFunction()}>
            <LogoutIcon /> Log out
          </MenuItem>
        )}
      </Header>
      <PageTransition>
        <Content>{children}</Content>
      </PageTransition>
      <Footer />
      <ToastContainer
        transition={Slide}
        position="bottom-right"
        autoClose={5000}
        closeOnClick
        draggable
        pauseOnHover
      />
    </StyledLayout>
  )
}

export default Layout

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  background-color: var(--background-color);
  color: var(--text-color);

  &.theme-dark {
    --background-color: #111;
    --text-color: #fff;
  }

  &.theme-light {
    --background-color: #fff;
    --text-color: #000;
  }

  @media print {
    color: #000 !important;
  }
`

const Content = styled.main`
  padding: 80px 5px;
  width: 800px;
  margin: 0 auto;
  min-height: 100vh;

  @media only screen and (max-width: 820px) {
    width: 100%;
  }
`
const MenuItem = styled.button`
  background: none;
  border: none;
  width: 100%;
  text-align: left;
  height: 100%;
  padding: 8px 10px 8px 20px;
  cursor: pointer;
  display: flex;
  align-items: center;
`

const LogoutIcon = styled(FaSignOutAlt)`
  margin-right: 10px;
`

const DarkModeIcon = styled(FaLightbulb)`
  margin-right: 10px;
`
